var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.5C8.25 2.42893 6.57107 0.75 4.5 0.75C2.42893 0.75 0.75 2.42893 0.75 4.5C0.75 6.57107 2.42893 8.25 4.5 8.25C6.57107 8.25 8.25 6.57107 8.25 4.5Z",
    stroke: "#3C7795",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 4.5C19.25 2.42893 17.5711 0.75 15.5 0.75C13.4289 0.75 11.75 2.42893 11.75 4.5C11.75 6.57107 13.4289 8.25 15.5 8.25C17.5711 8.25 19.25 6.57107 19.25 4.5Z",
    stroke: "#3C7795",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 15.5C19.25 13.4289 17.5711 11.75 15.5 11.75C13.4289 11.75 11.75 13.4289 11.75 15.5C11.75 17.5711 13.4289 19.25 15.5 19.25C17.5711 19.25 19.25 17.5711 19.25 15.5Z",
    stroke: "#3C7795",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.5C8.25 13.4289 6.57107 11.75 4.5 11.75C2.42893 11.75 0.75 13.4289 0.75 15.5C0.75 17.5711 2.42893 19.25 4.5 19.25C6.57107 19.25 8.25 17.5711 8.25 15.5Z",
    stroke: "#3C7795",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5f0cf5bf1329ef9582a54b6f6fdfdfee.svg";
export { ForwardRef as ReactComponent };